import { cn } from '@/lib/utils';
import type { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
    className?: string;
}

export const DataText: React.FC<Props> = ({ children, className = '' }) => {
    return <span className={cn('tabular-nums', className)}>{children}</span>;
};
